import { render } from "./RightSection.vue?vue&type=template&id=f33b96c8"
import script from "./RightSection.vue?vue&type=script&lang=js"
export * from "./RightSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__